module.exports = __webpack_public_path__ + "img/lv12.da6de895.png";